/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

/**
 * Utility function to assign a new URL to the current window location.
 * @param url {string} - The URL to navigate to.
 */
export const assignUrl = (url) => {
  window.location.assign(url);
};

/**
 * Utility function to reload the current page.
 */
export const reload = () => {
  window.location.reload();
};
